export const LogoMark = ({ size = 34 }) => (
  <svg viewBox="0 0 100 100" width={size} height={size} className="shrink-0"
    role="img" aria-label="REAM" data-testid="logo-mark">
    <rect x="4" y="4" width="92" height="92" rx="22" fill="hsl(243 75% 59%)" />
    <rect x="4" y="4" width="92" height="92" rx="22" fill="url(#reamGrad)" />
    <defs>
      <linearGradient id="reamGrad" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#6366F1" />
        <stop offset="100%" stopColor="#4338CA" />
      </linearGradient>
    </defs>
    <g stroke="#ffffff" strokeOpacity="0.22" strokeWidth="2.5">
      <path d="M4 38 H96" />
      <path d="M4 66 H96" />
      <path d="M34 4 V96" />
      <path d="M66 4 V96" />
    </g>
    <path
      d="M30 26h24c9.4 0 17 7.6 17 17 0 7.3-4.6 13.5-11.1 15.9L74 76H58.5L48 60.5h-5V76H30V26Zm13 12v11h11c3 0 5.5-2.5 5.5-5.5S57 38 54 38H43Z"
      fill="#ffffff"
    />
    <circle cx="72" cy="28" r="6.5" fill="#22D3EE" />
  </svg>
);

export const Logo = ({ size = 34, tone = "light", className = "" }) => {
  const onDark = tone === "light";
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="app-logo">
      <LogoMark size={size} />
      <span className="leading-none">
        <span
          className={`block font-display font-extrabold tracking-tighter ${onDark ? "text-white" : "text-foreground"}`}
          style={{ fontSize: size * 0.72 }}
        >
          REAM
        </span>
        <span
          className={`block uppercase font-semibold ${onDark ? "text-white/45" : "text-muted-foreground"}`}
          style={{ fontSize: Math.max(7.5, size * 0.2), letterSpacing: "0.16em", marginTop: 4 }}
        >
          Real Estate Asset Mgmt
        </span>
      </span>
    </div>
  );
};
